export class StatusType {
  public static Draft = 'DFT';
  public static Submitted = 'SUB';
  public static Approved = 'APV';
  public static InReview = 'IRC';
  public static Rejected = 'REJ';
  public static Cancelled = 'CAN';
  public static Pending = 'PEN';
  public static AdjournmentPending = 'ADJPEN';
  public static AdjournmentRejected = 'ADJREJ';
  public static AdjournmentSineDiePending = 'ADJSDPEN';
  public static AdjouredSineDie = 'ADJSD';
  public static Adjourned = 'ADJ';
}
